import React from "react"

const FormLabel = (props) => {
    const {name} = props

    return (
        <label htmlFor={name}>
            {name}
        </label>
    );
}

export default FormLabel
